import React from 'react'
import { FormGroup, Input } from 'reactstrap'

interface IinputProp {
  required?: boolean
  label: string | undefined
  options: any
  onChange?: (option: any) => void
  value: any
}

const InlineRadioField: React.FC<IinputProp> = (props) => {
  // *variable declarations
  const { options } = props
  const [checked, setStateChecked] = React.useState()

  // cwrp
  React.useEffect(() => {
    // *componentWillReceiveProps
    setStateChecked(props.value)
  }, [props.value])

  return (
      <FormGroup className="labeledField">
        <div className="mt-2">
          {options.map((current: any, index: number) => (
            <label className="c-radio mr-4" key={index}>
              <Input
                type="radio"
                onChange={(event: any) => {
                  setStateChecked( event.target.value)
                  if (props.onChange) {
                    props.onChange(event.target.value)
                  }
                }}
                value={current.value}
                checked={current.value === checked}
              />
              <span className="fa fa-circle"></span>
              {current.name}
            </label>
          ))}
        </div>
      </FormGroup>
    )

}

export default InlineRadioField
